import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { SvgUri } from 'react-native-svg';
import PropTypes from 'prop-types';
import CdnImage from '../common/CdnImage';
import { StyledWebView } from '../common/StyledWebView';
import ComponentContainer from '../common/ComponentContainer';

const STYLED_WEB_VIEW_ID = 'ImageWithDescription';

const ImageWithDescription = ({ customFill, description, height, image, nodeTypeAlias = 'ImageWithDescription', width }) => {
    if (!image) {
        return null;
    }

    const imgExt = image.cdnImagePath.substring(image.cdnImagePath.length - 4, image.cdnImagePath.length);

    return (
        <ComponentContainer dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {imgExt?.equals('.svg') && !Platform.OS.equals('web') && <SvgUri uri={`https:${image.cdnImagePath}`} height={height} width={width} fill={customFill} />}
            {imgExt.equals('.svg') && Platform.OS.equals('web') && <CdnImage omitWrapperStyle={true} uri={`https:${image.cdnImagePath}`} width={width} />}
            {!imgExt.equals('.svg') && <CdnImage omitWrapperStyle={true} uri={`https:${image.cdnImagePath}`} width={width} />}
            {!!description && (
                <View
                    style={StyleSheet.flatten(Styles.descriptionWrapper, {
                        marginHorizontal: 10,
                        marginVertical: 10
                    })}
                >
                    <StyledWebView html={description} nodeId={STYLED_WEB_VIEW_ID} width={width} />
                </View>
            )}
        </ComponentContainer>
    );
};

const Styles = StyleSheet.create({
    descriptionWrapper: {
        alignItems: 'center',
        justifyContent: 'center'
    }
});

ImageWithDescription.propTypes = {
    customFill: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isMobile: PropTypes.bool,
    image: PropTypes.shape({
        cdnImagePath: PropTypes.string.isRequired
    }),
    description: PropTypes.string,
    insideComponentContainer: PropTypes.bool
};

export default ImageWithDescription;
